import { useEffect, useState } from "react";
import { Plus, MapPin, Pencil, Trash2, ExternalLink } from "lucide-react";
import { epicengageSupabasev1 } from "../../../../../integrations/supabase/client";
import { useMerchant } from "../../../../../hooks/useMerchantEngageV1";
import { Button } from "../../../../ui/button";
import { Input } from "../../../../ui/input";
import { Label } from "../../../../ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../../../ui/card";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "../../../../ui/dialog";
import { Badge } from "../../../../ui/badge";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../../ui/select";
import { useToast } from "../../../../../hooks/use-toast";
import {  apiUrl, clientheaderconfig, frontURL  } from '../../../../Helpers/Config';
import axios from "axios";
import cookie from "react-cookies";

export type Outlet = {
  id: string;
  merchant_id: string;
  name: string;
  address: string | null;
  google_review_url: string | null;
  is_active: boolean;
};
export type outeltListType = {_id:string, value:string, label:string, outletsupabaseEngageV1OutletID:string, outletslug:string, outletAddress:string}

export const OutletsManager = () => {
  const { merchant } = useMerchant();
  const { toast } = useToast();
  const [outlets, setOutlets] = useState<Outlet[]>([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState<Outlet | null>(null);
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [reviewUrl, setReviewUrl] = useState("");
  const [saving, setSaving] = useState(false);

  const [outletList, setOutletList] = useState<outeltListType[]>([]);
  const [selectedOutlet, setSelectedOutlet] = useState("");
  const [pendingOutlet, setPendingOutlet] = useState(0);
  

  useEffect(() => {
    loadOutlet()
  }, [])

  const loadOutlet = async () => {
    const companyID = cookie.load("companyID");
    const urlShringTxt = apiUrl + "outlet/dropdown?company_id=" + companyID;
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          const result =  res.data.result;
          setOutletList(result);
          let pendingOutlet = 0;
          result.map((item:outeltListType)=> {
            if(item.outletsupabaseEngageV1OutletID=="" || item.outletsupabaseEngageV1OutletID===null) {
              pendingOutlet++;
            }
            return '';
          })
          setPendingOutlet(pendingOutlet)
        }
      })
      .catch();
  }

  const load = async () => {
    if (!merchant) return;
    setLoading(true);
    const { data, error } = await epicengageSupabasev1
      .from("outlets")
      .select("id, merchant_id, name, address, google_review_url, is_active")
      .eq("merchant_id", merchant.id)
      .order("created_at", { ascending: true });
    if (error) toast({ title: "Failed to load outlets", description: error.message, variant: "destructive" });
    else setOutlets((data as Outlet[]) ?? []);
    setLoading(false);
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [merchant?.id]);

  const openNew = () => {
    setEditing(null);
    setSelectedOutlet('')
    setName(""); setAddress(""); setReviewUrl("");
    setOpen(true);
  };
  const openEdit = (o: Outlet) => {
    setEditing(o);
    const selectedoutletDetails = outletList.find(c => c.outletsupabaseEngageV1OutletID === o.id);
    console.log(selectedoutletDetails, 'selectedoutletDetails')
    if(selectedoutletDetails) {
      setSelectedOutlet(selectedoutletDetails.value)
    }
    setName(o.name); setAddress(o.address ?? ""); setReviewUrl(o.google_review_url ?? "");
    setOpen(true);
  };

  const save = async () => {
    console.log(merchant, 'merchantmerchantmerchant')
    if (!merchant) return;
    if (!name.trim()) {
      toast({ title: "Name required", variant: "destructive" });
      return;
    }
    setSaving(true);
    const payload = {
      merchant_id: merchant.id,
      name: name.trim(),
      address: address.trim() || null,
      google_review_url: reviewUrl.trim() || null,
    };
    const { data, error } = editing
      ? await epicengageSupabasev1.from("outlets").update(payload).eq("id", editing.id).select("id").single()
      : await epicengageSupabasev1.from("outlets").insert(payload).select("id").single();
      console.log(data, 'datadatadatadata')
    setSaving(false);
    if (error) {
      toast({ title: "Save failed", description: error.message, variant: "destructive" });
      return;
    }

    updatesupabase(data.id)
    toast({ title: editing ? "Outlet updated" : "Outlet added" });
    setOpen(false);
    load();
  };


  const updatesupabase = (supabaseID:any) => {
    const selectedoutletDetails = outletList.find(c => c.value === selectedOutlet);
        const postObject = {
          supabaseIDType:'Engagev1',
          outletID: selectedoutletDetails.value,
          supabaseID
        };
        axios
          .post(apiUrl + "outlet/updatesupabase", postObject, clientheaderconfig)
          .then((res) => {
            console.log(res.data, "res.datares.datares.data");
            loadOutlet()
          })
          .catch((e) => {
            console.log(e);
          });
    }

  const remove = async (o: Outlet) => {
    /* if (!confirm(`Delete outlet "${o.name}"?`)) return; */
    const { error } = await epicengageSupabasev1.from("outlets").delete().eq("id", o.id);
    if (error) toast({ title: "Delete failed", description: error.message, variant: "destructive" });
    else { toast({ title: "Outlet deleted" }); load(); }
  };
  const changeOutlet = (outletID:string) => {
    const selectedoutletDetails = outletList.find(c => c.value === outletID);
    if(selectedoutletDetails!==null) {
      setName(selectedoutletDetails.label)
      setAddress(selectedoutletDetails.outletAddress)
      setReviewUrl(`${frontURL}review/${selectedoutletDetails.outletslug}`)
      setSelectedOutlet(outletID);
    }else {
      setName('')
      setAddress('')
      setReviewUrl('')
      setSelectedOutlet('');
    }
  }
  

  return (
    <Card>
      <CardHeader className="flex flex-row items-start justify-between gap-4">
        <div>
          <CardTitle className="text-base">Outlets</CardTitle>
          <CardDescription>Physical locations and their Google review URLs</CardDescription>
        </div>
        {pendingOutlet>0 &&
          <Button variant="outline" size="sm" onClick={openNew}>
            <Plus className="h-4 w-4" /> Connect Outlet
          </Button>
        }
      </CardHeader>
      <CardContent>
        {loading ? (
          <p className="text-sm text-muted-foreground">Loading…</p>
        ) : outlets.length === 0 ? (
          <p className="text-sm text-muted-foreground">No outlets yet. Add your first location to start sending review requests.</p>
        ) : (
          <div className="space-y-2">
            {outlets.map((o) => (
              <div key={o.id} className="flex items-start justify-between gap-4 rounded-md border border-border p-3">
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <MapPin className="h-4 w-4 text-muted-foreground shrink-0" />
                    <span className="font-medium truncate">{o.name}</span>
                    {!o.google_review_url && (
                      <Badge variant="outline" className="bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-950/30 dark:text-amber-200">
                        No review URL
                      </Badge>
                    )}
                  </div>
                  {o.address && <p className="text-xs text-muted-foreground mt-1 ml-6">{o.address}</p>}
                  {o.google_review_url && (
                    <a
                      href={o.google_review_url}
                      target="_blank"
                      rel="noreferrer"
                      className="text-xs text-primary hover:underline mt-1 ml-6 inline-flex items-center gap-1"
                    >
                      Google review URL <ExternalLink className="h-3 w-3" />
                    </a>
                  )}
                </div>
                <div className="flex items-center gap-1 shrink-0">
                  <Button variant="ghost" size="icon" onClick={() => openEdit(o)} aria-label="Edit">
                    <Pencil className="h-4 w-4" />
                  </Button>
                  <Button variant="ghost" size="icon" onClick={() => remove(o)} aria-label="Delete">
                    <Trash2 className="h-4 w-4" />
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{editing ? "Edit outlet" : "Add outlet"}</DialogTitle>
            <DialogDescription>
              Set the location name, address, and the Google review URL customers should land on.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-3">
            <div className="space-y-1.5">
              <Label htmlFor="outlet-name">Name</Label>
              <Select  value={selectedOutlet} onValueChange={changeOutlet}>
                <SelectTrigger className="mt-1.5"><SelectValue placeholder="Select Outlet" /></SelectTrigger>
                <SelectContent>
                  {outletList.map((r, index) => { 
                    if(editing) {
                      if(editing.id===r.outletsupabaseEngageV1OutletID) {
                        return (<SelectItem key={index} value={r._id}>{r.label}</SelectItem>);
                      }else {
                        return ''
                      }
                    }else {
                      if(r.outletsupabaseEngageV1OutletID==="" || r.outletsupabaseEngageV1OutletID===null) { return (<SelectItem key={index} value={r._id}>{r.label}</SelectItem>); } else { return ''; }
                    }  })}
                </SelectContent>
              </Select>
              {/* <Input id="outlet-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Nanyang Dao — Orchard" /> */}
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="outlet-address">Address</Label>
              <Input id="outlet-address" value={address} onChange={(e) => setAddress(e.target.value)} placeholder="123 Orchard Rd, Singapore" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="outlet-url">Google review URL</Label>
              <Input id="outlet-url" value={reviewUrl} onChange={(e) => setReviewUrl(e.target.value)} placeholder="https://g.page/r/..." />
              <p className="text-xs text-muted-foreground">Find this in your Google Business Profile under "Get more reviews".</p>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={save} disabled={saving}>{saving ? "Saving…" : "Save"}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </Card>
  );
};
